// Used in many store components

import { RouterReducerState } from "@ngrx/router-store";
import * as fromRoot from "#core/router-store";

export function getSelectedEntity<T>(
    entities: Map<number | string, T>,
    router: RouterReducerState<fromRoot.RouterStateUrl>,
    property: string,
    skipParse?: boolean
): T | null {
    if (router) {
        const getter = skipParse
            ? router.state.params[property]
            : parseInt(router.state.params[property], 10);
        let entity = entities.get(getter);
        if (property === "districtID" || property === "schoolID") {
            // ids are string not integer
            entity = entities.get(router.state.params[property]);
        } else if (property === "userID") {
            // retrieve number id from map string object
            entities.forEach((user) => {
                if ((<any>user).userID === getter) {
                    entity = user;
                }
            });
        } else if (property === "teacherID") {
            // retrieve number id from map string object
            entities.forEach((user) => {
                if ((<any>user).id === getter) {
                    entity = user;
                }
            });
        }
        if (entity !== undefined) {
            return entity;
        }
    }
    return null;
}
